import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setSearchEdit } from 'redux/actions';

import ArticleSearchBar from './article-search-bar';
import ArticleSearchTable from './article-search-table';
import ArticleSearchProducts from './article-search-products';
import ArticleSearchTotals from './article-search-totals';

import './article-search.scss';
import './base-search-table.scss';
import './article-search-table.scss';
import './article-search-products.scss';

function MerchantArticleSearch(props) {
	// State
	const { merchantId, searchType } = props.match.params;
	const [showTable, setShowTable] = useState(false);
	const [filter, setFilter] = useState(searchType);
	const [chips, setChips] = useState([]);
	const edit = useSelector((state) => state.edit);
	const dispatch = useDispatch();

	// Captures filter changes from navigation, searchType is in URL
	useEffect(() => {
		if (filter !== searchType) {
			setFilter(searchType);
		}
	}, [searchType]);

	// Render
	const totals = showTable ? (
		<ArticleSearchTotals
			orgId={merchantId}
			filter={filter}
			chips={chips}
		/>
	) : null;
	const table = showTable ? (
		edit ? (
			<ArticleSearchProducts
				edit={edit}
				orgId={merchantId}
				history={props.history}
				match={props.match}
				location={props.location}
			/>
		) : (
			<ArticleSearchTable
				orgId={merchantId}
				filter={filter}
				chips={chips}
				history={props.history}
				match={props.match}
				location={props.location}
			/>
		)
	) : null;

	return (
		<div className={`merchant-article-search ${showTable ? 'show-table' : ''}`}>
			<div className="article-search-container">
				<ArticleSearchBar
					orgId={merchantId}
					filter={filter}
					update={(chips) => {
						setChips(chips);
						setShowTable(!!chips.length);
						dispatch(setSearchEdit(null));
					}}
					updateFilter={(val) => setFilter(val)}
					showTable={showTable}
				/>
			</div>
			{totals}
			{table}
		</div>
	);
}

export default withRouter(MerchantArticleSearch);
